export const INSPECTION_BASE_PATH = "/inspection";
export const INSPECTION_USER_KEY = "INSPECTION_User_Id";

export function getInspectionUserId() {
  return localStorage.getItem(INSPECTION_USER_KEY);
}

export function setInspectionUserId(userId) {
  localStorage.setItem(INSPECTION_USER_KEY, userId);
}

export function clearInspectionSession() {
  localStorage.removeItem(INSPECTION_USER_KEY);
}

/** Prefix an inspection-relative path, e.g. path("carsteps") -> "/inspection/carsteps" */
export function inspectionPath(path = "") {
  if (!path || path === "/") {
    return INSPECTION_BASE_PATH;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (normalized.startsWith(INSPECTION_BASE_PATH)) {
    return normalized;
  }
  return `${INSPECTION_BASE_PATH}${normalized}`;
}
